<template>
    <v-form v-model="valid" ref="form">
    <v-container fluid class="mt-4">
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-text-field label="Description on sales forms" v-model="spirit.sellingDescription" :rules="[fieldRules.maxLength(50)]" :counter="50" outlined dense/>
        </v-col>
      </v-row>

      <v-row dense v-if="values && connectedToAccounting">
        <v-col cols="12" sm="6" md="4">
          <account-picker v-model="spirit.incomeAccountRef" label="Income account"
                          :accounts="incomeAccounts" :addTypes="['Income']"
                          hint="The income account is used to track sales of this spirit."/>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <account-picker v-model="spirit.cogAccountRef" label="Expense account"
                          :accounts="cogAccounts" :addTypes="['CostOfGoodsSold']"
                          hint="The cost of goods account is used to track sales of this spirit"/>
        </v-col>
      </v-row>

      <v-row >
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input dense label="Default price" v-model="spirit.defaultPrice" :precision="4" suffix="/LAA"/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <v-autocomplete  outlined dense label="Default tax" v-model="spirit.defaultTaxId" :items="taxes" item-value="id" item-text="name"/>
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-checkbox dense label="Commission exempt" v-model="spirit.commissionExempt"/>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" md="10" lg="8">
          <customer-pricing :customers="spirit.customers" :taxes="taxes" units="LAA"
                            :default-sku="spirit.sku" :defaultPrice="spirit.defaultPrice" :defaultTaxId="spirit.defaultTaxId"/>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import CustomerPricing from '@/components/CustomerPricing'

export default {
  name: 'SpiritsEditSelling',
  components: {CustomerPricing},
  props: {
    spirit: {type:Object, required:true},
    taxes: {type:Array, required:true},
    incomeAccounts: {type:Array, required:true},
    cogAccounts: {type:Array, required:true},
    values: {type:Boolean, required:true}
  },
  data() {
    return {
      valid: true
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    }
  }
}
</script>